import React, { useCallback } from 'react';
import { Checkbox } from '@tinper/next-ui';
import _ from 'lodash';

import './CardItem.less';
import CardOperations from "./CardTableOperations";

function Info (props) {
  const { label, value, bodyDisplayInRow } = props;
  return <div className={`as-cardTable-item-info `}>
    <div className={'as-cardTable-item-info-label'}>{label ? label + ':' : ''}</div>
    <div className={`${bodyDisplayInRow ? "as-cardTable-item-content-ellp as-cardTable-item-info-value" : "as-cardTable-item-info-value"}`} title={value}>&nbsp;{value}</div>
  </div>
}

function getText (cardIndex, columns, data, index) {
  const column = columns.find(item => item.cardIndex === cardIndex) || {};
  const { dataIndex, render } = column;
  let text = _.get(data, dataIndex, '');

  if (cardIndex === 2) { // 当是img时需要特殊处理
    text = <img src={text} className={'as-cardTable-item-card-img'}/>
  }
  if (typeof render === 'function') {
    text = render(text, data, index)
  }
  return text;
}

function getOtherTexts (columns, data, index, bodyDisplayInRow) {
  const otherColumns = (columns.filter(item => item.cardIndex && item.cardIndex > 0 && ![0, 1, 2].includes(item.cardIndex)) || [])
    .sort((a, b) => a.cardIndex - b.cardIndex);
  return otherColumns.map(item => {
    const { title, dataIndex, cardTitle, render } = item;
    const label = cardTitle === false ? false : (cardTitle || title);
    let value = _.get(data, dataIndex, '');
    if (typeof render === 'function') {
      value = render(value, data, index)
    }
    return <Info label={label} key={item.cardIndex} bodyDisplayInRow={bodyDisplayInRow} value={value}/>
  })
}

function CardItem (props) {
  const {
    columns,
    data,
    bodyDisplayInRow,
    index,
    operationType,
    operationTypeProps,
    operationItems,
    operationClick,
    rowKey,
    onRowClick,
    onRowDoubleClick,
    selectedRowKeys,
    rowSelection,
    onSelect,
    bordered,
    itemType,
    fieldid
  } = props;
  const { maxCount = 3, hoverVisible = false } = operationTypeProps;
  // const newOperationItems = getOperationItems({operationItems,deleteInfo,onDelete});
  const operationProps = {
    operationItems,
    operationItemsMaxCount: maxCount,
    record: data,
    index,
    operationType,
    operationClick,
    fieldid
  }
  let operationRender = null;
  if (typeof itemType === 'function') {
    const res = operationType(operationItems, data, index);
    if (res instanceof Array) {
      operationRender = <CardOperations {...operationProps} operationItems={res}/>
    } else {
      operationRender = res
    }
  } else {
    if (!operationItems.length) {
      operationRender = null
    } else {
      operationRender = <CardOperations {...operationProps}/>
    }
  }

  const tag = getText(0, columns, data, index);
  const selectHandle = useCallback(function (e) {
    onSelect(e.target.checked, data)
  }, [onSelect])
  const checked = selectedRowKeys.includes(data[rowKey])

  const onDoubleClickCard = useCallback((e) => {
    onRowDoubleClick && onRowDoubleClick(data, index, e);
  })

  const onClickCard = useCallback((e) => {
    onRowClick && onRowClick(data, index, e);
  })

  return <div onClick={onClickCard} onDoubleClick={onDoubleClickCard} className={ `as-cardTable-item  ${bordered ? 'as-cardTable-item-bordered' : ''} ${hoverVisible ? ' as-cardTable-item-hover' : ''}`}>
    {
      tag && <div className={'as-cardTable-item-tag'}>{tag}</div>
    }

    {
      itemType === 'horizontal'
        ? <div className={`as-cardTable-item-horizontal ${bodyDisplayInRow ? "as-cardTable-item-ellp" : ""}`}>
          {getText(2, columns, data, index)}
          <div className={"as-cardTable-item-cotent-container"}>
            <div className={'as-cardTable-item-title'}>
              <span>{getText(1, columns, data, index)}</span>
              {
                rowSelection && <div className={'as-cardTable-item-select-icon'}>
                  <Checkbox onClick={selectHandle} checked={checked}/></div>
              }
            </div>
            <div >
              {
                getOtherTexts(columns, data, index, bodyDisplayInRow)
              }
            </div>
          </div>

        </div>
        : <div className={`as-cardTable-item-cotent-container ${bodyDisplayInRow ? "as-cardTable-item-ellp" : ""}`}>
          <div className={'as-cardTable-item-title'}>
            <span>{getText(1, columns, data, index)}</span>
            {
              rowSelection && <div className={'as-cardTable-item-select-icon'}>
                <Checkbox onClick={selectHandle} checked={checked}/></div>
            }
          </div>
          <div className={'as-cardTable-item-horizontal'}>
            {getText(2, columns, data, index)}
            <div className='as-cardTable-item-cotent-container'>
              {
                getOtherTexts(columns, data, index, bodyDisplayInRow)
              }
            </div>
          </div>
        </div>
    }

    {
      (operationRender)
        ? <div className={ hoverVisible ? 'as-cardTable-item-footer as-cardTable-item-hover-footer' : 'as-cardTable-item-footer as-cardTable-item-no-hover-footer'}>
          {operationRender}
        </div>
        : <div style={{ height: 16 }}></div>
    }

  </div>
}

export default CardItem
